import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import 'swiper/dist/css/swiper.css';
import 'vant/lib/index.css';

import './assets/style/event.scss'

Vue.config.productionTip = false

import { gioAction, changePageInfo } from '@/uitls/page'
Vue.prototype.$gioAction = gioAction
Vue.prototype.$changePageInfoCommon = changePageInfo

// 初始化设备监听
store.dispatch('device/initDeviceListener')

// 全局混入GrowingIO页面参数设置
Vue.mixin({
  mounted() {
    if (window.location.href.indexOf('/products/detail/')>-1){
      return;
    }
    const pageRecord = this.pageRecord || {}
    const gioParams = {
      module_pvar: pageRecord.module || '',
      category1_pvar: pageRecord.category1 || '',
      category2_pvar: pageRecord.category2 || '',
      category3_pvar: pageRecord.category3 || '',
      title_pvar: pageRecord.title || '',
      url_pvar: location.href,
      mediaSources_pvar: pageRecord.mediaSources || '',
      linkSource_pvar: pageRecord.linkSource || '',
      behaviorType_pvar: pageRecord.behaviorType || '浏览网页',
      behaviorResult_pvar: pageRecord.behaviorResult || '浏览成功'
    }
    if (window.gio && pageRecord.module) {
      window.gio('page.set', gioParams)
    }
  }
})

Vue.use({
  install(Vue) {
    if (store.state.device.isPC) {
      import('element-ui').then(Element => {
        Vue.use(Element)
      })
    } else {
      import('vant').then(Vant => {
        Vue.use(Vant)
      })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
